import { gql } from '@apollo/client';

export const AUTHENTICATE_MUTATION = gql`
  mutation authenticate($username: String!, $password: String!) {
    authenticate(username: $username, password: $password) {
      authData {
        accessToken
        expiresIn
      }
    }
  }
`;

export const USER_ACCOUNT_QUERY = gql`
  query getUserAccount($accessToken: String!) {
    userAccount(accessToken: $accessToken) {
        id
      login
      password
      firstName
      lastName
      phone
      email
      activated
      langKey
      authorities
      accountType
      companyName
      companyId
      companyType
      country {
        id
        countryId
        name
        nameJa
        latitude
        longitude
        tax {
          label
          percent
        }
      }
      lastModifiedBy
      lastModifiedDate
      ecommerceDomainName
      userCompanyName
      userCompanyId
      userCompanyAddress
      userCompanyPhoneNumber
      platform
      userCountry
      userCity
      industry
      jobTitle
    }
  }
`;

export const REGISTER_MUTATION = gql`
  mutation register($username: String!, $email: String!, $password: String!) {
    register(username: $username, email: $email, password: $password) {
      id
      username
      email
    }
  }
`;

export const Get_Country_Code = gql`
  query getCountryCodeNoToken($ownerId: String!) {
    getCountryCodeNoToken(ownerId: $ownerId) {
      countryId
      countryName
    }
  }
`;

export const Get_Currency_Code_Details = gql`
  query getCurrencyCodeDetails($countryCurrencyCode: String!) {
    currencyCodeDetails(countryCurrencyCode: $countryCurrencyCode) {
      currencyCode
      currencySymbol
    }
  }
`;

export const FORGET_PASSWORD = gql`
  mutation forgetPassword($email: String!, $platformSource: String!, $platformBaseUrl: String!, $publisherId: String!) {
    forgetPassword(email: $email, platformSource: $platformSource, platformBaseUrl: $platformBaseUrl, publisherId: $publisherId) {
      message
    }
  }
`;

export const CHECK_REGISTRATION = gql`
  mutation CheckRegistration($companyId: String!, $field: String!, $value: String!) {
    checkRegistration(companyId: $companyId, field: $field, value: $value) {
      results {
        field
        errors
        valid
      }
    }
  }
`;

export const RESET_PASSWORD_FINISH = gql`
  mutation ResetPasswordFinish($key: String!, $newPassword: String!) {
    resetPasswordFinish(key: $key, newPassword: $newPassword) {
      success
      statusCode
    }
  }
`;